export interface PlatformInitialState {
  platform: string
  handlerPlatform: (platform: string) => void
}

export const platformInitialState: PlatformInitialState = {
  platform: 'ios',
  handlerPlatform: () => {},
}
